import Vue       from 'vue'
import VueRouter from 'vue-router'
import Home      from '../views/Home.vue'
import NotFound  from '../views/NotFound.vue'

Vue.use(VueRouter)

const router = new VueRouter({
	mode   : 'history',
	base   : process.env.BASE_URL,
	routes : [
		{ path: '/'                     ,name: 'Home'               ,component: Home },
		{ path: '/news'                 ,name: 'News'               ,component: () => import('../views/News.vue') },
		{ path: '/play'                 ,name: 'Downloads'          ,component: () => import('../views/Downloads.vue') },
		{ path: '/feature'              ,name: 'Feature'            ,component: () => import('../views/Feature.vue') },
		{ path: '/report'               ,name: 'Report'             ,component: () => import('../views/Report.vue') },
		{ path: '/contact'              ,name: 'Contact'            ,component: () => import('../views/Contact.vue') },
		{ path: '/privacy'              ,name: 'Privacy'            ,component: () => import('../views/Privacy.vue') },
		{ path: '/terms-and-conditions' ,name: 'TermsAndConditions' ,component: () => import('../views/TermsAndConditions.vue') },
		{ path: '/players/:playerId'    ,name: 'Players'            ,component: () => import('../views/Players.vue') },
		{ path: '/matches/:matchId'     ,name: 'Matches'            ,component: () => import('../views/Matches.vue') },
		{ path: '/changelogs/:id'       ,name: 'Changelogs'         ,component: () => import('../views/Changelog.vue') },
		{ path: '/roadmap'              ,name: 'Preview'            ,component: () => import('../views/Preview.vue') },

		// Mazes
		{ path: '/mazes'                ,name: 'Mazes'              ,component: () => import(/* webpackChunkName: "maze-gallery" */ '../views/Mazes.vue') },
		{ path: '/mazes/side'           ,name: 'SideMazes'          ,component: () => import(/* webpackChunkName: "maze-gallery" */ '../views/MazeGallery.vue') },
		{ path: '/mazes/goal'           ,name: 'GoalMazes'          ,component: () => import(/* webpackChunkName: "maze-gallery" */ '../views/MazeGallery.vue') },
		// { path: '/mazes/user'           ,name: 'UserMazes'          ,component: () => import(/* webpackChunkName: "maze-gallery" */ '../views/MazeGallery.vue') },
		{ path: '/mazes/:mazeId'        ,name: 'MazeItem'           ,component: () => import(/* webpackChunkName: "maze-gallery" */ '../views/MazeItem.vue') },

		// Catch Not-Found
		{ path: '*'                                                 ,component: NotFound },
	],
})

router.beforeEach((to, from, next) => {
	if (to.path !== from.path) {
		window.scrollTo(0, 0)
	}

	next()
})

export default router
